export default class Donor {
  // @ts-ignore
  public id: string;
  public weight: number | null;
  public birthday: Date;
  public bloodType: number | null;
  public rh: string;

  // @ts-ignore
  public grid: string;
  // @ts-ignore
  public genders: [];
  // @ts-ignore
  public bloodTypes: [];
  // @ts-ignore
  public rhs: [];
  // @ts-ignore
  public hlas: [];

  public inaccessibilityNote: string;

  constructor() {
    this.weight = null;
    this.birthday = new Date();
    this.bloodType = null;
    this.rh = '';
    this.inaccessibilityNote = '';
  }
}
